export default "__VITE_ASSET__C0dxk1dg__"